export default {
  notificationTabs: [],
  notifications: { order: [], PO: [], сustomerProof: []},
  rolesNotification: {},
  myOrders: false,
  testOrders: false
};
